import { h } from "preact";
export function DeliveryAddressDivider() {
    return h("div", { class: "m-delivery-address__br" });
}
